import { render, staticRenderFns } from "./FormQuestionImage.vue?vue&type=template&id=51d5634c&"
import script from "./FormQuestionImage.vue?vue&type=script&lang=js&"
export * from "./FormQuestionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports